module.exports = __webpack_public_path__ + "29c587e6cf1705132b046c5f2bd321df.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/LeagueGothic/leaguegothic-regular-webfont.woff
// module id = 353
// module chunks = 0